var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MyHttpClient } from '../app/http-client.service';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { chunkList, mergeTicketLists, paginateTicketList, shouldFetchNextTicketPage, TICKET_BOOKING_ID_QUERY_CHUNK_SIZE, TICKET_CONVERSATION_COMMENT_LIMIT, TICKET_V2_DEFAULT_PAGE_SIZE, } from './shared/ticket-table.helper';
import * as i0 from "@angular/core";
import * as i1 from "./http-client.service";
var UserTicketingService = /** @class */ (function () {
    function UserTicketingService(http) {
        this.http = http;
        this.server = environment.server;
        this.fetchTicketsV2Url = this.server + "/api/user/tickets/v2";
        this.fetchTicketsV3Url = this.server + "/api/user/tickets/v3";
        this.fetchTicketCommentsUrl = this.server + "/api/user/tickets/v1/comments";
    }
    UserTicketingService.prototype.fetchUserTicketsV2 = function (userId, userType, query, pageNumber, pageSize) {
        var _this = this;
        if (pageSize === void 0) { pageSize = TICKET_V2_DEFAULT_PAGE_SIZE; }
        var parsedQuery = this.parseTicketQuery(query);
        var bookingIds = parsedQuery && parsedQuery.booking_id;
        if (Array.isArray(bookingIds)) {
            if (bookingIds.length === 0) {
                return of({ tickets: [] });
            }
            var chunks = chunkList(bookingIds, TICKET_BOOKING_ID_QUERY_CHUNK_SIZE);
            return forkJoin(chunks.map(function (chunk) {
                return _this.fetchAllPagesForQuery(userId, userType, __assign({}, parsedQuery, { booking_id: chunk }));
            })).pipe(map(function (ticketLists) {
                var tickets = mergeTicketLists(ticketLists);
                return {
                    tickets: pageSize ? paginateTicketList(tickets, pageNumber, pageSize) : tickets
                };
            }), catchError(this.handleError));
        }
        return this.requestTicketsV2(userId, userType, query, pageNumber).pipe(catchError(this.handleError));
    };
    UserTicketingService.prototype.fetchAllPagesForQuery = function (userId, userType, queryObj, pageNumber) {
        var _this = this;
        if (pageNumber === void 0) { pageNumber = 1; }
        return this.requestTicketsV2(userId, userType, JSON.stringify(queryObj), pageNumber).pipe(switchMap(function (response) {
            var tickets = (response && response.tickets) || [];
            if (shouldFetchNextTicketPage(tickets)) {
                return _this.fetchAllPagesForQuery(userId, userType, queryObj, pageNumber + 1).pipe(map(function (nextTickets) { return tickets.concat(nextTickets); }));
            }
            return of(tickets);
        }));
    };
    UserTicketingService.prototype.requestTicketsV2 = function (userId, userType, query, pageNumber) {
        return this.http.get(this.fetchTicketsV2Url + "/" + userId + "?userType=" + userType + "&query=" + encodeURIComponent(query) + "&page=" + pageNumber);
    };
    UserTicketingService.prototype.parseTicketQuery = function (query) {
        try {
            return JSON.parse(query);
        }
        catch (error) {
            return null;
        }
    };
    UserTicketingService.prototype.fetchUserTicketsV3 = function (userId, userType, query, pageNumber, limit) {
        if (limit === void 0) { limit = 30; }
        return this.http.get(this.fetchTicketsV3Url + "/" + userId + "?userType=" + userType + "&query=" + encodeURIComponent(query) + "&page=" + pageNumber + "&limit=" + limit).pipe(catchError(this.handleError));
    };
    UserTicketingService.prototype.fetchUserTicketsByMobileV3 = function (userId, userType, mobile, pageNumber, limit) {
        if (pageNumber === void 0) { pageNumber = 1; }
        if (limit === void 0) { limit = 30; }
        var query = JSON.stringify({ mobile: mobile });
        return this.fetchUserTicketsV3(userId, userType, query, pageNumber, limit);
    };
    UserTicketingService.prototype.fetchTicketConversation = function (userId, ticketId) {
        return this.fetchTicketLastComment(userId, ticketId, true, TICKET_CONVERSATION_COMMENT_LIMIT);
    };
    UserTicketingService.prototype.fetchTicketLastComment = function (userId, ticketId, includePrivate, perPage) {
        return this.http.get(this.fetchTicketCommentsUrl + "/" + ticketId + "/" + userId + "?includePrivate=" + includePrivate + "&perPage=" + perPage).pipe(catchError(this.handleError));
    };
    UserTicketingService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        }
        else {
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        return throwError(error);
    };
    UserTicketingService.ngInjectableDef = i0.defineInjectable({ factory: function UserTicketingService_Factory() { return new UserTicketingService(i0.inject(i1.MyHttpClient)); }, token: UserTicketingService, providedIn: "root" });
    return UserTicketingService;
}());
export { UserTicketingService };
